import type { Profile } from '@/constant/schema';

export type ClassJoinPromptStatus = 'pending' | 'skipped' | 'joined';
export type ClassJoinPromptSource =
  | 'post_onboarding_home_modal'
  | 'signup_teacher_code'
  | 'referral_teacher_code'
  | 'manual';

export type ClassJoinPromptState = {
  status?: ClassJoinPromptStatus;
  prompted_at?: string;
  completed_at?: string;
  joined_via?: ClassJoinPromptSource;
};

type OnboardData = NonNullable<Profile['onboard_data']>;

export function getClassJoinPromptState(profile: Profile | null | undefined): ClassJoinPromptState | null {
  const state = (profile?.onboard_data as Record<string, unknown> | null | undefined)?.class_join_prompt;
  if (!state || typeof state !== 'object') {
    return null;
  }
  return state as ClassJoinPromptState;
}

export function mergeClassJoinPromptIntoOnboardData(
  profile: Profile | null | undefined,
  updates: ClassJoinPromptState,
): OnboardData {
  const currentOnboardData = (profile?.onboard_data || {}) as OnboardData;
  const currentPrompt = getClassJoinPromptState(profile) || {};

  return {
    ...currentOnboardData,
    class_join_prompt: {
      ...currentPrompt,
      ...updates,
    },
  };
}
